import api from '@/apis/di/bankInfoAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useBankInfoComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBankInfoComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'bank_account';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',bank_info_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const bankInfoComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng, kho bạc',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 420,
      },
    ],
    displayField: 'bank_name',
    valueField: 'bank_name',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankInfoComboboxLoadData,
  };

  const bankInfoComboConfig1 = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng, kho bạc',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 420,
      },
    ],
    displayField: 'bank_account',
    valueField: 'bank_account',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankInfoComboboxLoadData,
  };

  const bankInfoComboConfig2 = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'bank_account',
        width: 180,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng, kho bạc',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 420,
      },
    ],
    displayField: 'bank_account',
    valueField: 'bank_account',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankInfoComboboxLoadData,
  };

  return {
    bankInfoComboConfig,
    bankInfoComboConfig1,
    bankInfoComboConfig2,
    onBankInfoComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
